import React from "react";
import CollapsibleWrapper from "../CollapsibleWrapper";
import ExpertMessage from "../ExpertMessage";

const ExpertMessageContent = ({
  msg,
  index,
  messageId,
  initialExpanded,
  onToggle,
  shouldCollapseByValue,
  renderCopyButton,
  styles,
  adoptedExpertOpinions,
  handleOpinionAdoption,
}) => {
  return (
    <div className={`message-content-wrapper ${styles.messageContentWrapper || ""}`}>
      <CollapsibleWrapper
        messageId={messageId}
        collapsible={shouldCollapseByValue(msg.context)}
        initialExpanded={initialExpanded}
        onToggle={onToggle}
      >
        <ExpertMessage
          content={msg.context}
          messageIndex={index}
          adoptedOpinions={adoptedExpertOpinions[index] || []}
          onOpinionAdoption={(lineIndex, isAdopted) =>
            handleOpinionAdoption(index, lineIndex, isAdopted)
          }
          isError={msg.isError}
          isProcessing={msg.isProcessing === "true"}
          styles={styles}
        />
      </CollapsibleWrapper>
      {renderCopyButton(msg.context)}
    </div>
  );
};

export default React.memo(ExpertMessageContent);
